module.exports = __webpack_public_path__ + "static/media/seriousCall.1e1256ed.mp3";